import styled from 'styled-components';

export const LoadingWrapper = styled.div`
    width: 100%;
    height: 100%;
    border-radius: 1.2rem;
    background-color: rgba(0, 0, 0, 0.54);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1;
`;

export const LoadingCar = styled.div`
    width: 431px;
    height: 231px;
    border-radius: 0.8rem;
    background-color: #ffffff;
    position: fixed;
    left: 50%;
    top: 340px;
    transform: translateX(-50%);
    overflow: hidden;
    @keyframes moveRight {
        0% {
            transform: translateX(0);
        }
        100% {
            transform: translateX(100%);
        }
    }
    .carCont{
        height: 12rem;
        border-bottom: dashed 0.2rem #2276e3;
    }
    .iconCont {
        width: 100%;
        animation: moveRight 4s linear infinite;
    }
    p{
        font-family: 'Rubik';
        font-size: 1.6rem;
        line-height: 2.4rem;
        font-weight: 600;
        color: #2276e3;
        text-align: center;
        margin-top: 1.5rem;
    }
`;